import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nav-highlights',
  templateUrl: './nav-highlights.component.html',
  styleUrls: ['./nav-highlights.component.scss']
})
export class NavHighlightsComponent implements OnInit {

  links = [];

  constructor() {
    this.links = [
      { title: 'Insights', stlyeclass: 'icon-insights', linkhref: '#insights/insights', iconname: 'fa-chart-pie'},
      //{ title: 'Videos', stlyeclass: 'icon-videos', linkhref: '#highlights/videos', svgname: 'video'},
      { title: 'Report', stlyeclass: 'icon-report', linkhref: '#insights/report', iconname: 'fa-file-alt'}      
    ];
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/AMEX/sites/cfo-research/src/app/nav-highlights/nav-highlights.component.ts